module.exports = __webpack_public_path__ + "media/KZ-PAV.ef69f19d.ogg";